/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10 ?
      '0' + (date.getMonth() + 1) :
      date.getMonth() + 1) + '-'
  let D =
    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  let h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':'
  let s =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
};
/**
 * 是否转换  0否   1是
 * @param {*} content  1  0
 */
const YesOrNo = (yesOrNo) => {

  if (yesOrNo == 1) {
    return "是"
  } else if (yesOrNo == 0) {
    return "否"
  }
};

/**
 * 性别  1男  2女
 * @param {*} content  1  0
 */
const Sex = (sex) => {

  if (sex == 1) {
    return "男"
  } else if (sex == 2) {
    return "女"
  }
};

/**
 * 启用 禁用  未启用状态转换  0禁用   1启用  2未启用
 * @param {*} content  1  0
 */
const StateCode = (stateCode) => {

  if (stateCode == 1) {
    return "启用"
  } else if (stateCode == 0) {
    return "禁用"
  } else if (stateCode == 2) {
    return "未启用"
  }
};

/**
 * @param {*} content  1  0
 */
const OrderStatus = (orderStatus) => {
  if (orderStatus == -1) {
    return "正在合成"
  }else if (orderStatus == 0) {
    return "待合成"
  } else if (orderStatus == 1) {
    return "待发货"
  } else if (orderStatus == 2) {
    return "已发货"
  }
};

/**
 * @param {*} content  1  0
 */
const FileStatus = (fileStatus) => {

  if (fileStatus == 0) {
    return "已合成"
  } else if (fileStatus == 1) {
    return "已发货"
  }
};

/**
 * 未生效 已生效  已过期状态转换  0未生效   1已生效   2已过期
 * @param {*} content  1  0
 */
const PromoteStatus = (promoteStatus) => {

  if (promoteStatus == 0) {
    return "未生效"
  } else if (promoteStatus == 1) {
    return "已生效"
  } else if (promoteStatus == 2) {
    return "已过期"
  }
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + '=([^;]+)');
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return '';
  }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
};

/**
 * 导出
 **/
export {
  timestampToTime,
  YesOrNo,
  Sex,
  StateCode,
  PromoteStatus,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  OrderStatus,
  FileStatus
}



// WEBPACK FOOTER //
// ./src/utils/util.js